export default "__VITE_ASSET__CWW34P$m__"